import { createContext, useContext } from 'react';

interface TourContextValue {
  startTour: (role: string) => void;
}

export const TourContext = createContext<TourContextValue | null>(null);

export function useTourContext() {
  return useContext(TourContext);
}
